import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ArrowLeftSmallIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: attributes.width || size,
    height: attributes.height || size,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17845 12.5333L8.93315 16.2833C9.22761 16.5774 9.70503 16.5774 9.99949 16.2833C10.2939 15.9892 10.2939 15.5124 9.99949 15.2183L7.52138 12.7508L19.2286 12.7508C19.6433 12.7508 19.9795 12.4151 19.9795 12.0008C19.9795 11.5866 19.6433 11.2508 19.2286 11.2508L7.52138 11.2508L9.99949 8.78334C10.1417 8.64251 10.2216 8.45082 10.2216 8.25084C10.2216 8.05086 10.1417 7.85916 9.99949 7.71834C9.85849 7.57635 9.66655 7.49649 9.46632 7.49649C9.26609 7.49649 9.07415 7.57635 8.93315 7.71834L5.17845 11.4683C5.03629 11.6092 4.95632 11.8009 4.95632 12.0008C4.95632 12.2008 5.03629 12.3925 5.17845 12.5333Z",
    fill: color,
    fillOpacity: "0.945098"
  }));
};
export default ArrowLeftSmallIcon;